/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Sweet_NeutralInputs */

const en_coach_sweet_neutral = /** @type {(inputs: Coach_Sweet_NeutralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your training load is balanced with your recovery. This is normal day-to-day training territory. Keep following your plan and focus on aerobic development and consistency.`)
};

const de_coach_sweet_neutral = /** @type {(inputs: Coach_Sweet_NeutralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umfang und Erholung sind im Gleichgewicht. Normales Alltagstraining. Bleib an deinem Plan dran — Fokus auf aerobe Entwicklung und Konstanz.`)
};

/**
* | output |
* | --- |
* | "Your training load is balanced with your recovery. This is normal day-to-day training territory. Keep following your plan and focus on aerobic development an..." |
*
* @param {Coach_Sweet_NeutralInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_sweet_neutral = /** @type {((inputs?: Coach_Sweet_NeutralInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Sweet_NeutralInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_sweet_neutral(inputs)
	return de_coach_sweet_neutral(inputs)
});